export default __webpack_public_path__ + "static/media/2.76a934c9.jpg";